// extracted by mini-css-extract-plugin
module.exports = {"Link":"Link__1RyJm"};